export default __webpack_public_path__ + "static/media/Crossbow of the Blood Drinker.56fdf29d.jpg";